import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { array, bool, func, number, object, string } from 'prop-types'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import ArrowheadDownIcon from '../../atoms/icons/arrowhead-down-icon'
import AccordionGroup from '../accordion/accordion-group'
import Filter from './filter'
import { BorderIcon, ButtonMoreFilters, Root, Title } from './filters.styled'

const Filters = ({
	items,
	loading,
	maxFiltersCount,
	onApplyFilter,
	showCountOnOption,
	showCountOnTitle,
	onShowMoreFilters,
	showMoreButton,
	showMoreButtonProps,
	priceVariant,
	className,
	exclusive,
	...props
}) => {
	const { formatMessage } = useIntl()
	const {
		price: { filterVariant: filterPriceVariant },
	} = useConfig()
	const priceFilterVariant = priceVariant || filterPriceVariant

	const [filterCount, setFilterCount] = useState(maxFiltersCount)

	const onShowMoreFiltersHandler = (e, itemsCount) => {
		setFilterCount(itemsCount)
		if (onShowMoreFilters) {
			onShowMoreFilters(e, itemsCount)
		}
	}

	return (
		<Root id="Filters-root" className={className}>
			<AccordionGroup
				exclusive={exclusive}
				defaultExpanded={exclusive ? items[0]?.id : items.map(({ id }) => id)} // array of filterId to be expanded
				accordions={items
					.slice(0, showMoreButton ? filterCount : items.length) // limit filters to show by filterCount prop
					.map(({ id, label, count, values, range }) => {
						return {
							id: id,
							className: id,
							title: (
								<Title component="p" variant={'button'}>
									<span>{label}</span> {showCountOnTitle && count ? <span>{'(' + count + ')'}</span> : null}
								</Title>
							),
							content: (
								<Filter
									count={count}
									id={id}
									key={id}
									loading={loading}
									onApplyFilter={onApplyFilter}
									range={range}
									showCountOnOption={showCountOnOption}
									values={values}
									priceVariant={priceFilterVariant}
								/>
							),
							expandIcon: (
								<BorderIcon>
									<ArrowheadDownIcon fontSize="medium" />
								</BorderIcon>
							),
						}
					})}
				{...props}
			/>
			{showMoreButton && items.length > maxFiltersCount && (
				<ButtonMoreFilters
					variant="outlined"
					label={formatMessage({ id: items.length > filterCount ? 'filter_show_more' : 'filter_hide_more' })}
					onClick={(e) => onShowMoreFiltersHandler(e, items.length > filterCount ? items.length : maxFiltersCount)}
					{...showMoreButtonProps}
				/>
			)}
		</Root>
	)
}

Filters.defaultProps = {
	maxFiltersCount: 2,
	showCountOnOption: true,
	showCountOnTitle: true,
	showMoreButton: true,
	exclusive: true,
}

Filters.propTypes = {
	activeFilterProps: object,
	items: array.isRequired,
	loading: bool,
	maxFiltersCount: number.isRequired,
	onApplyFilter: func,
	showCountOnOption: bool,
	showCountOnTitle: bool,
	showMoreButton: bool,
	onShowMoreFilters: func,
	showMoreButtonProps: object,
	priceVariant: string,
}

export default Filters
